<mat-form-field
  TsFieldStyling
  [fieldBackgroundColor]="fieldStyling().color"
  [fieldBold]="fieldStyling().is_bold"
  [targetStylingClass]="commonTargetStylingClass"
  targetTextClass=".mat-select-value"
  class="flex-auto gt-xs:pr-3 w-full"
  (click)="edit()"
  (focus)="edit()"
>
  <mat-label>
    <span
      class="block text-ellipsis overflow-hidden pointer-events-auto"
      [matTooltip]="fieldDef.label"
      tooltipIfEllipsis
    >
      {{ fieldDef.label }}
    </span>
  </mat-label>
  <div class="w-full">
    @if (fieldDef.meta?.value_hidden) {
      <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
    } @else {
      <mat-select
        (selectionChange)="onSelectionChange()"
        [(ngModel)]="value"
        (blur)="onBlur()"
        [disabled]="isDisabled"
        [ngClass]="{ 'disabled': isDisabled }"
      >
        <mat-option *ngFor="let option of options" [value]="option.id">{{ option.value }}</mat-option>
      </mat-select>
    }
  </div>
</mat-form-field>
